var styles = [".usertag[_ngcontent-%COMP%]{color:#fff;text-shadow:0 0 3px #000;box-shadow:0 0 4px #000;border-radius:15px}.pl-1[_ngcontent-%COMP%]{padding-left:.2rem!important}.pr-1[_ngcontent-%COMP%]{padding-right:.2rem!important}"];
export { styles as styles };
